import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PaginationService } from 'src/app/services/utils/pagination.service';

@Component({
  selector: 'pipeline-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() config: any;
  @Input() view: any;

  @Output() onPaginationButtonClick = new EventEmitter();
  @Output() onPaginationConfigUpdated = new EventEmitter();

  buttons: any[] = [];

  constructor(
    private paginationService: PaginationService,
  ) {
  }

  public async calculate() {
    try {
      this.view.loading = true;

      const calc: any = await this.paginationService.calculateConfig(this.view || {}, this.config || {});

      if (!calc) {
        return false;
      }

      if (calc.hasOwnProperty('buttons')) {
        this.buttons = (calc.buttons || []);
      }

      if (!!calc.config) {
        this.config = calc.config;
      }

      if (!!calc.view) {
        this.view = calc.view;
      }

      this.view.loading = false;
    } catch (e) {
      console.warn('calc failed', e);
      this.view.loading = false;
    }
  }

  ngOnInit() {
    this.calculate();
  }

  onButtonClick(button: any) {
    this.config = this.config || {};
    this.config.offset = button.index;
    this.calculate();
  }

  onLimitChanged(event: any = null) {

    if (!!this.config && !!this.config.hasOwnProperty('limit')) {
      this.paginationService.setLimit(this.config.limit);
    }

    this.calculate();
  }

  async paginateBack() {
    try {
      this.view.loading = true;

      const calc: any = await this.paginationService.calculateBack(this.view || {}, this.config || {});

      if (!calc) {
        return false;
      }

      if (calc.hasOwnProperty('buttons')) {
        this.buttons = (calc.buttons || []);
      }

      if (!!calc.config) {
        this.config = calc.config;
      }

      if (!!calc.view) {
        this.view = calc.view;
      }

      this.view.loading = false;
    } catch (e) {
      console.warn('pagination: calc back failed', e);
      this.view.loading = false;
    }
  }

  async paginateNext() {
    try {
      this.view.loading = true;

      const calc: any = await this.paginationService.calculateNext(this.view || {}, this.config || {});

      if (!calc) {
        return false;
      }

      if (calc.hasOwnProperty('buttons')) {
        this.buttons = (calc.buttons || []);
      }

      if (!!calc.config) {
        this.config = calc.config;
      }

      if (!!calc.view) {
        this.view = calc.view;
      }

      this.view.loading = false;
    } catch (e) {
      console.warn('pagination: calc next failed', e);
      this.view.loading = false;
    }
  }

}